import { render } from "./ConfigListaGridsView.vue?vue&type=template&id=fbece636"
import script from "./ConfigListaGridsView.vue?vue&type=script&lang=js"
export * from "./ConfigListaGridsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Induscapas\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__